import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { MY_DEPARTMENT_GROUPS, NO_DEPARTMENT_GROUP } from './departmentGroup';

interface DepartmentGroupSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: { sorted: string[]; hasUngrouped: boolean };
  myGroups: string[];
  myGroupsLabel: string;
  labelId: string;
}

const DepartmentGroupSelect: React.FC<DepartmentGroupSelectProps> = ({
  value,
  onChange,
  options,
  myGroups,
  myGroupsLabel,
  labelId,
}) => (
  <FormControl size="small" fullWidth>
    <InputLabel id={labelId}>Department Group</InputLabel>
    <Select
      labelId={labelId}
      label="Department Group"
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
    >
      {myGroups.length > 1 && <MenuItem value={MY_DEPARTMENT_GROUPS}>My groups ({myGroupsLabel})</MenuItem>}
      <MenuItem value="all">All</MenuItem>
      {options.sorted.map((group) => (
        <MenuItem key={group} value={group}>
          {group}
        </MenuItem>
      ))}
      {options.hasUngrouped && <MenuItem value={NO_DEPARTMENT_GROUP}>No department group</MenuItem>}
    </Select>
  </FormControl>
);

export default DepartmentGroupSelect;
